import { images } from '../constants';

const services = [
    {
        id: 1,
        image: images.service1,
        title: 'Emergency Response',
        content: 'Customized planning for rapid and effective response to fire emergencies.',
        paragraphs: [
            'Count on us during emergencies. Our rapid response service ensures swift and effective handling of critical situations, providing expert guidance and support when you need it the most.',
            'Whether it\'s urgent decision-making, crisis management, or emergency coordination, our team is dedicated to delivering prompt assistance in times of need.'
        ],
        gallery: [
            images.service1Gallery1,
            images.service1Gallery2
        ],
        features: [
            'Rapid Situation Assessment',
            'Crisis Management',
            'Coordination with Emergency Services',
            'Expert Guidance in Critical Situations',
            'Swift Decision-making Support'
        ],
        procedure: [
            'Situation Assessment',
            'Emergency Coordination',
            'Expert Guidance Delivery',
            'Crisis Management',
            'Follow-up and Support'
        ],
        faqs: [
            {
                id: 1,
                heading: 'How quickly can you respond to emergencies?',
                content: 'Our emergency response team is trained to provide swift assistance, and our goal is to respond to emergencies within the shortest possible time frame.'
            },
            {
                id: 2,
                heading: 'What types of critical situations do you handle?',
                content: 'We handle a variety of critical situations, including but not limited to natural disasters, accidents, hazardous material incidents, and other emergencies requiring immediate attention.'
            },
            {
                id: 3,
                heading: 'Is the emergency response service available 24/7?',
                content: 'Yes, our emergency response service operates 24 hours a day, 7 days a week to ensure continuous support during emergencies.'
            },
            {
                id: 4,
                heading: 'How can I request emergency assistance?',
                content: 'You can request emergency assistance by calling our dedicated emergency hotline. Dispatchers will guide you through the process and coordinate the response.'
            }
        ]
    },
    {
        id: 2,
        image: images.service2,
        title: 'Safety Training',
        content: 'Comprehensive training programs to enhance fire safety awareness in the community.',
        paragraphs: [
            'Our safety training programs are designed to equip individuals and organizations with essential fire prevention knowledge and emergency response skills.',
            'Through workshops, hands-on simulations, and expert-led sessions, we aim to foster a safer and more prepared community.'
        ],
        gallery: [
            images.service2Gallery1,
            images.service2Gallery2
        ],
        features: [
            'Fire Safety Education Workshops',
            'Hands-on Fire Extinguisher Training',
            'Evacuation Drill Simulations',
            'First Aid & CPR Integration',
            'Customized Programs for Schools & Workplaces'
        ],
        procedure: [
            'Assess training needs for target audience',
            'Design and schedule tailored sessions',
            'Conduct interactive and practical training',
            'Evaluate participant performance and understanding',
            'Issue certificates and provide follow-up materials'
        ],
        faqs: [
            {
                id: 1,
                heading: 'Who can participate in the safety training programs?',
                content: 'Our programs are open to individuals, schools, organizations, and community groups looking to improve fire safety knowledge.'
            },
            {
                id: 2,
                heading: 'Do you offer certification upon training completion?',
                content: 'Yes, participants receive a certificate of completion that highlights their acquired fire safety skills.'
            },
            {
                id: 3,
                heading: 'Are the training sessions customizable?',
                content: 'Absolutely. We tailor each program based on your needs, location, and participant age group or profession.'
            },
            {
                id: 4,
                heading: 'How long does a typical training session last?',
                content: 'Sessions range from 2 to 4 hours depending on the depth and type of training requested.'
            }
        ]
    },
    {
        id: 3,
        image: images.service3,
        title: 'Equipment Maintenance',
        content: 'Regular maintenance to ensure firefighting equipment is efficient and ready for emergencies.',
        paragraphs: [
            'Our equipment maintenance service focuses on keeping firefighting tools and gear in top operational condition, reducing risks during real-time emergencies.',
            'By conducting routine inspections, testing, and repairs, we ensure all equipment meets safety standards and is ready for rapid deployment.'
        ],
        gallery: [
            images.service3Gallery1,
            images.service3Gallery2
        ],
        features: [
            'Routine Inspection of Firefighting Tools',
            'Preventive Maintenance Scheduling',
            'On-site Equipment Testing & Calibration',
            'Certified Technicians & Safety Compliance',
            'Repair and Replacement Services'
        ],
        procedure: [
            'Schedule regular maintenance checks',
            'Conduct thorough inspection of all gear',
            'Perform cleaning, testing, and calibration',
            'Document findings and necessary repairs',
            'Certify equipment readiness and safety'
        ],
        faqs: [
            {
                id: 1,
                heading: 'How often is equipment maintenance performed?',
                content: 'Maintenance is scheduled monthly or quarterly, depending on usage and equipment type.'
            },
            {
                id: 2,
                heading: 'What equipment do you service?',
                content: 'We maintain hoses, extinguishers, breathing apparatuses, ladders, turnout gear, and more.'
            },
            {
                id: 3,
                heading: 'Are the technicians certified?',
                content: 'Yes, all maintenance is handled by certified professionals who follow industry and safety standards.'
            },
            {
                id: 4,
                heading: 'Do you offer emergency repair services?',
                content: 'Yes, we provide 24/7 emergency repair support for critical equipment failures.'
            }
        ]
    },
    {
        id: 4,
        image: images.service4,
        title: 'Fire Drills',
        content: 'Conducting drills to ensure the community is prepared for fire-related incidents.',
        paragraphs: [
            'Our fire drill programs simulate real-life fire emergencies to test preparedness, response time, and effectiveness of evacuation procedures.',
            'These drills are designed to educate individuals and teams on safe evacuation routes, emergency protocols, and how to act swiftly during an actual fire situation.'
        ],
        gallery: [
            images.service4Gallery1,
            images.service4Gallery2
        ],
        features: [
            'Realistic Emergency Simulations',
            'Evacuation Planning and Execution',
            'Awareness of Fire Escape Routes',
            'Team Coordination Exercises',
            'Post-Drill Review and Feedback'
        ],
        procedure: [
            'Plan the drill scenario with safety protocols',
            'Notify participants and stakeholders',
            'Conduct the drill with live simulations',
            'Monitor response times and actions taken',
            'Review outcomes and suggest improvements'
        ],
        faqs: [
            {
                id: 1,
                heading: 'How often should fire drills be conducted?',
                content: 'It is recommended to conduct fire drills at least twice a year or as required by safety regulations.'
            },
            {
                id: 2,
                heading: 'Who participates in fire drills?',
                content: 'All community members, employees, or facility occupants are encouraged to participate to ensure full preparedness.'
            },
            {
                id: 3,
                heading: 'What happens after a fire drill?',
                content: 'A debrief is conducted to review performance, identify gaps, and suggest areas for improvement.'
            },
            {
                id: 4,
                heading: 'Do fire drills include emergency service coordination?',
                content: 'Yes, we often coordinate with local fire departments for more realistic and comprehensive simulations.'
            }
        ]
    },
    {
        id: 5,
        image: images.service5,
        title: 'Incident Investigations',
        content: 'Thorough investigations to determine the cause of fire incidents for prevention.',
        paragraphs: [
            'Our incident investigation services provide in-depth analysis to uncover the root causes of fire incidents, helping to prevent future occurrences.',
            'We work closely with fire departments and safety experts to identify hazards, unsafe practices, and system failures that contributed to the incident.'
        ],
        gallery: [
            images.service5Gallery1,
            images.service5Gallery2
        ],
        features: [
            'Detailed Fire Cause Analysis',
            'Collaboration with Fire Departments',
            'Identification of Fire Safety Gaps',
            'Recommendations for Prevention Measures',
            'Expert Testimony for Legal Proceedings'
        ],
        procedure: [
            'Gather evidence from the incident site',
            'Interview witnesses and involved parties',
            'Analyze physical evidence and data',
            'Determine the fire’s origin and cause',
            'Prepare a comprehensive report with findings and recommendations'
        ],
        faqs: [
            {
                id: 1,
                heading: 'What types of incidents do you investigate?',
                content: 'We investigate all types of fire incidents, from residential fires to industrial explosions, to understand the causes and prevent recurrence.'
            },
            {
                id: 2,
                heading: 'How long does an investigation take?',
                content: 'The duration varies depending on the complexity of the incident, but we aim to complete most investigations within 2-3 weeks.'
            },
            {
                id: 3,
                heading: 'Do you work with insurance companies?',
                content: 'Yes, we provide detailed reports that can be used by insurance companies for claims processing.'
            },
            {
                id: 4,
                heading: 'Are your investigations admissible in court?',
                content: 'Our investigations are thorough and conducted according to industry standards, making them suitable for use in legal proceedings.'
            }
        ]
    },
    {
        id: 6,
        image: images.service6,
        title: 'Mitigation Consultation',
        content: 'Consultations to identify and mitigate potential hazards for enhanced safety.',
        paragraphs: [
            'Our mitigation consultation services help identify potential hazards within your environment and provide expert recommendations to reduce risks.',
            'We focus on proactive safety measures to enhance overall protection against fire-related incidents, ensuring compliance with safety standards and regulations.'
        ],
        gallery: [
            images.service6Gallery1,
            images.service6Gallery2
        ],
        features: [
            'Comprehensive Hazard Identification',
            'Risk Assessment and Analysis',
            'Personalized Mitigation Strategies',
            'Safety Protocol Development',
            'Regulatory Compliance Assistance'
        ],
        procedure: [
            'Conduct an on-site hazard analysis',
            'Assess potential risks and vulnerabilities',
            'Develop tailored mitigation strategies',
            'Implement risk reduction measures',
            'Monitor and evaluate the effectiveness of the mitigation plan'
        ],
        faqs: [
            {
                id: 1,
                heading: 'What is hazard mitigation?',
                content: 'Hazard mitigation involves identifying potential risks and implementing strategies to prevent or minimize the impact of those hazards on people, property, and the environment.'
            },
            {
                id: 2,
                heading: 'How can mitigation consultation help my business?',
                content: 'Our consultations help identify safety gaps, ensuring your business complies with safety regulations and minimizing the risk of fire hazards.'
            },
            {
                id: 3,
                heading: 'Is the consultation suitable for residential properties?',
                content: 'Yes, our mitigation consultation services are available for both commercial and residential properties, aiming to reduce hazards and improve safety for everyone.'
            },
            {
                id: 4,
                heading: 'How do I get started with a mitigation consultation?',
                content: 'You can request a consultation by contacting our team, who will schedule a site visit to assess potential hazards and develop a mitigation plan tailored to your needs.'
            }
        ]
    }

];

export default services;